/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreditDebtSummary,
  DownloadCsvParams2,
  GetParams5,
  LifecycleEventDto,
  StatementDto,
} from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiStatementController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-statement-controller
   * @name Get
   * @request GET:/api/v1/statements
   */
  get = (query: GetParams5, params: RequestParams = {}) =>
    this.http.request<StatementDto[], any>({
      path: `/v1/statements`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getPath = '/v1/statements'
  static getMethod = 'GET'
  /**
   * No description
   *
   * @tags api-statement-controller
   * @name DownloadPdf
   * @request GET:/api/v1/statements/{statementId}/pdf
   */
  downloadPdf = (statementId: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/statements/${statementId}/pdf`,
      method: 'GET',
      ...params,
    })

  static downloadPdfPath = '/v1/statements/${statementId}/pdf'
  static downloadPdfMethod = 'GET'
  /**
   * No description
   *
   * @tags api-statement-controller
   * @name GetEventsByStatementId
   * @request GET:/api/v1/statements/{statementId}/events
   */
  getEventsByStatementId = (statementId: string, params: RequestParams = {}) =>
    this.http.request<LifecycleEventDto[], any>({
      path: `/v1/statements/${statementId}/events`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getEventsByStatementIdPath = '/v1/statements/${statementId}/events'
  static getEventsByStatementIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-statement-controller
   * @name DownloadCsv
   * @request GET:/api/v1/statements/{statementId}/csv
   */
  downloadCsv = ({ statementId, ...query }: DownloadCsvParams2, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/statements/${statementId}/csv`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static downloadCsvPath = '/v1/statements/${statementId}/csv'
  static downloadCsvMethod = 'GET'
  /**
   * No description
   *
   * @tags api-statement-controller
   * @name Warnings
   * @request GET:/api/v1/statements/warnings
   */
  warnings = (params: RequestParams = {}) =>
    this.http.request<CreditDebtSummary, any>({
      path: `/v1/statements/warnings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static warningsPath = '/v1/statements/warnings'
  static warningsMethod = 'GET'
}
